import { lazy, useState } from 'react';
import { Alert } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';
import Tooltip from 'src/componentes/tooltip';
import { FormattedMessage, useIntl } from 'react-intl';
import ValidarRestricaoNovo from 'src/componentes/validar-restricao-novo/ValidarRestricao';

import Input from 'src/componentes/input';
import CheckBox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import PeriodicidadeLookup from 'src/lookups/periodicidade';
import StatusItemLookup from 'src/lookups/status-item';
import Panel from 'src/componentes/panel-collapse';
import MatrizRisco from 'src/lookups/matriz-risco';
import TipoRiscoLookup from 'src/lookups/tipo-risco';
import ModeloRiscoLookup from 'src/lookups/modelo-risco';
import ClassificacaoRiscoLookup from 'src/lookups/classificacao-risco';
import { capitalizeFirstLetter } from 'src/utils/string';
import DataInicioTermino from 'src/paginas/formula/componentes/inicio-termino';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import ContentManager from 'src/componentes/content-manager';
import {
  MODULOS,
  ADDONS,
  STATUS_ITEM,
  TIPO_ITEM_FLUXO_APROVACAO,
  TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO,
} from 'src/utils/constants';
import FiltroItemRelatorioPowerBI from 'src/paginas/item/edit/resumo/filtro-relatorio-powerbi';

import TabelaItensAssociados from './risco-itens-associados/relacionamento';
import RiscoItensAssociados from './risco-itens-associados';
import PlanosContingenciaVinculadosView from './PlanosContingenciaVinculados/PlanosContingenciaVinculadosView';
import ToleranciaRiscoLookup from 'src/lookups/ToleranciaRiscoLookup';
import FluxoAprovacaoGenericoLookup from 'src/lookups/FluxoAprovacaoGenericoLookup';
import LucideIcon from 'src/componentes/lucide-icon';
import ModalFluxoAprovacaoStatus from './ModalFluxoAprovacaoStatus';
import ModalHistoricoFluxoAprovacaoStatus from './ModalHistoricoFluxoAprovacaoStatus';
import TagLookup from 'src/lookups/TagLookup';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import DicionarioRiscoLookup from 'src/lookups/DicionarioRiscos/DicionarioRiscoLookup';
import BreadcrumbsHierarquia from '../components/BreadcrumbsHierarquia/BreadcrumbsHierarquia';
import DocumentosAssociadosPanel from 'src/paginas/GestaoDocumentos/Documento/Components/DocumentosAssociadosPanel';
import DocumentoEditModal from 'src/paginas/GestaoDocumentos/Documento/DocumentoEdit';
import useAuth from 'src/hooks/useAuth';
import { useSelector } from 'src/store';
import { STATUS_SOLICITACAO_GESTAO_MUDANCAS } from 'src/utils/constants';

const Historico = lazy(() => import('src/paginas/versao-alteracao'));

const cadastroFieldClasses = String.raw`tw:[&_.mb-3>label]:flex tw:[&_.mb-3>label]:min-h-5 tw:[&_.mb-3>label]:leading-5 tw:[&_.mb-3>label]:mb-2 tw:[&_.mb-3>label>.pb-1]:inline-flex tw:[&_.mb-3>label>.pb-1]:pb-0! tw:[&_.form-group>.pb-2]:min-h-5 tw:[&_.form-group>.pb-2]:leading-5 tw:[&_.form-group>.pb-2]:mb-2 tw:[&_.form-group>.pb-2]:pb-0! tw:[&_.risco-cadastro-select\_\_control]:min-h-12`;

const RiscoResumoEdit = (props) => {
  const intl = useIntl();
  const [enviadoParaFluxoAprovacaoStatus, setEnviadoParaFluxoAprovacaoStatus] =
    useState(false);
  const { terms: resources, module, addons, configurations } = useAuth();
  const modules = useSelector((state) => state.user.licenca.modulos);
  const tiposAnexos = configurations?.tiposAnexos;

  const {
    model,
    disabled,
    configuracao,
    saved,
    rascunhoPendenteAprovacao,
    parameters,
  } = props;

  const [hasValueFluxoAprovacao, setHasValueFluxoAprovacaoState] =
    useState(true);

  const handleChangeUtilizarValorPowerBI = (checked) => {
    if (checked) {
      ContentManager.addContent(
        <ValidarRestricaoNovo
          title="labelAlterarConfiguracoesAvaliacoes"
          description="labelDescricaoAlterarConfiguracoesAvaliacoes"
          exibirEstouCiente={false}
          labelCancelar="label.cancelar"
          labelAlterar="alterar"
          width={700}
          minHeight={300}
          customHandleSalvarClick={() => {
            model.getModel('utilizarValorPowerBI').requestChange(true);
          }}
          customHandleCloseValidarRestricaoClick={() => {
            model.getModel('utilizarValorPowerBI').requestChange(false);
          }}
        />
      );
    } else {
      model.getModel('utilizarValorPowerBI').requestChange(false);
    }
  };

  const handleAreaChange = (value) => {
    model.getModel('area').requestChange(value);

    let usarCodigoArea = model.getModel('utilizarCodigoAreaParaMascara').value;
    if (usarCodigoArea) {
      let novoCodigoItem =
        value.idIntegracao + model.getModel('idIntegracao').value;
      model.getModel('idIntegracao').requestChange(novoCodigoItem);
    }
  };

  const handleOpenItensAssociados = () => {
    const isEPAtual = module?.id === MODULOS.ESCRITORIO_PROJETOS;
    const itDoesntHaveGRLicence =
      modules?.find((m) => m.id === MODULOS.GESTAO_RISCO && m.ativo) == null;

    const showOnlyProjects = isEPAtual && itDoesntHaveGRLicence;

    ContentManager.addContent(
      <RiscoItensAssociados
        modules={modules}
        showOnlyProjects={showOnlyProjects}
        model={model.getModel('itensAssociados')}
        risco={model.value}
        habilitarIndicadoresRisco={model.value.habilitarIndicadoresRisco}
      />
    );
  };

  /** @returns {boolean} configuração do risco habilitado para gerar idIntegração automático */
  const utilizaCodigoAutomatico = ({
    utilizarCodigoAutomatico,
    permitirAlterarCodigoAutomatico,
  }) => {
    const id = model.getModel('id').value;
    return (
      utilizarCodigoAutomatico && (!permitirAlterarCodigoAutomatico || id <= 0)
    );
  };

  const renderFiltroRelatorioPowerBI = (disabledAtual, modelAtual) =>
    modelAtual.getModel('itemRelatorioPowerBI').value && (
      <FiltroItemRelatorioPowerBI
        model={modelAtual.getModel('itemRelatorioPowerBI')}
        disabled={disabledAtual}
        itemId={modelAtual.getModel('id').value}
        tipoItemId={modelAtual.getModel('tipo').value?.id}
      />
    );

  const setHasValueFluxoAprovacao = (data) => {
    setHasValueFluxoAprovacaoState(data && data.length > 0);
  };

  const handleChangeFluxoAprovacao = (value) => {
    const configuracaoRiscoAtual = model.getModel('configuracaoRisco').value;
    const isNovo = model?.value?.id <= 0;

    if (
      value &&
      isNovo &&
      configuracaoRiscoAtual?.usarFluxoAprovacaoBelt &&
      !configuracaoRiscoAtual?.fluxoAprovacaoObrigatorioRisco
    ) {
      model.getModel('status').requestChange({ id: 1 });
    }
    model.getModel('fluxoAprovacao').requestChange(value);
  };

  const handleChangePeopleAndGroups = (list) => {
    const newApprovers =
      list?.filter((x) => x.identificadorLista === 'colaboradores') || [];
    const newGroups =
      list?.filter((x) => x.identificadorLista === 'grupos') || [];

    model.getModel('responsaveisMulti').requestChange(newApprovers);
    model.getModel('gruposResponsaveis').requestChange(newGroups);
    model
      .getModel('responsaveis')
      .requestChange([...newApprovers, ...newGroups]);
  };

  const handleOpenDocumentoAssociadoDetail = (itemDocumentoAssociado) => {
    const itemId = itemDocumentoAssociado?.id;
    const agrupador = itemDocumentoAssociado?.agrupador;

    if (!itemId) return;

    ContentManager.addContent(
      <DocumentoEditModal
        item={{ id: itemId }}
        endpoint="/Documento"
        isDocument={!agrupador}
        disabled
      />
    );
  };

  const hasGR = !!modules?.some(
    (m) => m.id === MODULOS.GESTAO_RISCO && m.ativo
  );
  const isEP = module?.id === MODULOS.ESCRITORIO_PROJETOS;

  const isNew = model?.value?.id <= 0;
  const configuracaoRisco = model.getModel('configuracaoRisco').value;
  const utilizarModelo =
    hasGR && !isEP && configuracaoRisco && configuracaoRisco.utilizarModelo;
  const utilizarClassificacaoRisco =
    configuracaoRisco && configuracaoRisco.utilizarClassificacaoRisco;
  const utilizarTipo = configuracaoRisco && configuracaoRisco.utilizarTipo;
  const utilizarToleranciaRisco = model?.getModel(
    'exibirToleranciaRisco'
  )?.value;
  const desabilitarToleranciaRisco = model?.getModel(
    'desabilitarToleranciaRisco'
  )?.value;
  const fluxoAprovacaoHabilitado = configuracaoRisco?.usarFluxoAprovacaoBelt;
  const fluxoAprovacaoObrigatorio =
    fluxoAprovacaoHabilitado &&
    configuracaoRisco?.fluxoAprovacaoObrigatorioRisco;
  const aguardandoSelecaoFluxoObrigatorio =
    hasGR &&
    fluxoAprovacaoHabilitado &&
    fluxoAprovacaoObrigatorio &&
    !model.getModel('fluxoAprovacao').value;
  const rowsDescricao = [
    utilizarModelo,
    utilizarClassificacaoRisco,
    utilizarTipo,
  ].reduce((acc, curr) => acc + (curr ? 3 : 0), 0);

  const existeFluxoAprovacao = model?.getModel('existeFluxoAprovacao')?.value;
  const responsaveis = model.getModel('responsaveisMulti').value || [];
  const gruposResponsaveis = model.getModel('gruposResponsaveis').value || [];
  const podeVisualizarTagRisco = configuracaoRisco?.podeVisualizarTag;
  const addonIntegracaoPowerBIAvaliacaoRisco =
    addons &&
    addons.find((m) => m.id === ADDONS.INTEGRACAO_POWERBI_AVALIACAORISCO)
      ?.ativo;
  const reprovadoDefinitivamente =
    model.getModel('status')?.value?.id === STATUS_ITEM.REPROVADO;

  const addonGestaoDocumentosAtivo = !!addons?.find(
    (a) => a.id === ADDONS.GESTAO_DOCUMENTOS
  )?.ativo;

  const disabledPorFluxoAprovacao =
    (fluxoAprovacaoObrigatorio &&
      model.getModel('pendenteAprovacao').value &&
      model.getModel('status')?.value?.id !==
        STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO) ||
    rascunhoPendenteAprovacao ||
    (isNew && model.getModel('fluxoAprovacao').value) ||
    (model.getModel('status')?.value?.id ===
      STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO &&
      !model.getModel('pendenteAprovacao').value);

  const solicitacaoMudancaStatusRisco = model.getModel(
    'solicitacaoMudancaStatus'
  )?.value;

  const statusSolicitacao = solicitacaoMudancaStatusRisco?.statusSolicitacao;

  const possuiFluxoReprovadoAguardandoSubmissaoStatus =
    statusSolicitacao?.id ===
    STATUS_SOLICITACAO_GESTAO_MUDANCAS.REPROVADO_AGUARDANDO_SUBMISSAO;

  const possuiFluxoAprovacaoStatusPendente =
    statusSolicitacao?.id == STATUS_SOLICITACAO_GESTAO_MUDANCAS.PENDENTE ||
    enviadoParaFluxoAprovacaoStatus;

  const statusItemLookupDisabled =
    disabled ||
    disabledPorFluxoAprovacao ||
    possuiFluxoAprovacaoStatusPendente ||
    possuiFluxoReprovadoAguardandoSubmissaoStatus;

  const desabilitarLookupFluxoAprovacaoStatus =
    possuiFluxoAprovacaoStatusPendente ||
    possuiFluxoReprovadoAguardandoSubmissaoStatus;

  const modalFluxoAprovacaoStatus = (
    statusAtual,
    statusDestino,
    fluxoAprovacao,
    observacaoSolicitacao,
    statusSolicitacao,
    statusIds,
    ehReenvio = false
  ) => {
    ContentManager.addContent(
      <ModalFluxoAprovacaoStatus
        statusAtual={statusAtual}
        statusDestino={statusDestino}
        fluxoAprovacao={fluxoAprovacao}
        riscoModel={model.value}
        parameters={parameters}
        observacaoSolicitacao={observacaoSolicitacao}
        statusSolicitacao={statusSolicitacao}
        statusIds={statusIds}
        ehReenvio={ehReenvio}
        enviadoParaAprovacao={(value) =>
          setEnviadoParaFluxoAprovacaoStatus(value)
        }
      />
    );
  };

  const abrirModalReenvioFluxoAprovacaoStatus = (statusDestinoSelecionado) => {
    const statusAtual = model.getModel('status')?.value;
    const fluxoAprovacaoStatus = model.getModel('fluxoAprovacaoStatus')?.value;

    const solicitacao = model.getModel('solicitacaoMudancaStatus')?.value;
    const statusDestino =
      statusDestinoSelecionado || solicitacao?.statusDestino;
    const observacaoSolicitacao = solicitacao?.observacao;
    const statusSolicitacao = solicitacao?.statusSolicitacao;
    const statusIds = fluxoAprovacaoStatus?.statusIds;

    const statusDestinoFormatado = statusDestino
      ? {
          ...statusDestino,
          descricao: intl.formatMessage({ id: statusDestino.descricao }),
        }
      : statusDestino;

    modalFluxoAprovacaoStatus(
      statusAtual,
      statusDestinoFormatado,
      fluxoAprovacaoStatus,
      observacaoSolicitacao,
      statusSolicitacao,
      statusIds,
      true
    );
  };

  const onStatusChange = (value) => {
    const statusAtual = model.getModel('status').value;

    const fluxoAprovacaoStatus = model.getModel('fluxoAprovacaoStatus').value;

    if (fluxoAprovacaoStatus != null && !isNew) {
      const statusIds = Array.isArray(fluxoAprovacaoStatus?.statusIds)
        ? fluxoAprovacaoStatus.statusIds
        : [];

      if (statusIds.includes(value.id)) {
        modalFluxoAprovacaoStatus(
          statusAtual,
          value,
          fluxoAprovacaoStatus,
          null,
          null,
          statusIds,
          false
        );

        return;
      }
    }

    model.getModel('status').requestChange(value);
  };

  const handleOpenHistoricoStatus = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    ContentManager.addContent(
      <ModalHistoricoFluxoAprovacaoStatus
        riscoId={model.getModel('id')?.value}
      />
    );
  };

  const exibirHistoricoFluxoStatus = solicitacaoMudancaStatusRisco != null;

  return (
    <div>
      {isNew &&
        !model.getModel('fluxoAprovacao').value &&
        aguardandoSelecaoFluxoObrigatorio && (
          <Panel header={<FormattedMessage id="label.informacoesBasicas" />}>
            <Row>
              {fluxoAprovacaoHabilitado &&
                isNew &&
                !model.getModel('fluxoAprovacao').value && (
                  <>
                    <Col md={4} style={{ paddingBottom: 20 }}>
                      <FluxoAprovacaoGenericoLookup
                        data-testid="risco-fluxo-aprovacao-lookup"
                        disabled={existeFluxoAprovacao}
                        data={{
                          tipoItemId: TIPO_ITEM_FLUXO_APROVACAO.RISCO,
                          tipoMudancaId:
                            TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO.INCLUSAO_RISCO,
                        }}
                        required={fluxoAprovacaoObrigatorio && isNew}
                        model={model.getModel('fluxoAprovacao')}
                        getDataLookup={setHasValueFluxoAprovacao}
                      />
                    </Col>
                    {!hasValueFluxoAprovacao && (
                      <Col md={8} style={{ paddingTop: 20 }}>
                        <Alert color="warning">
                          <LucideIcon icon="alert" />
                          <span className="ml-2">
                            {intl.formatMessage({
                              id: 'labelFluxoAprovacaoNaoCadastrado',
                            })}
                          </span>
                        </Alert>
                      </Col>
                    )}
                  </>
                )}
            </Row>
          </Panel>
        )}
      {(!aguardandoSelecaoFluxoObrigatorio ||
        model.getModel('fluxoAprovacao').value ||
        !isNew) && (
        <Panel header={<FormattedMessage id="label.informacoesBasicas" />}>
          <Row className={`pb-2 ${cadastroFieldClasses}`}>
            {fluxoAprovacaoHabilitado &&
              hasGR &&
              (isNew || model.getModel('fluxoAprovacao').value) && (
                <Col md={4}>
                  <FluxoAprovacaoGenericoLookup
                    classNamePrefix="risco-cadastro-select"
                    data-testid="risco-fluxo-aprovacao-lookup"
                    data={{
                      tipoItemId: TIPO_ITEM_FLUXO_APROVACAO.RISCO,
                      tipoMudancaId:
                        TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO.INCLUSAO_RISCO,
                    }}
                    required={fluxoAprovacaoObrigatorio}
                    disabled={
                      disabled ||
                      existeFluxoAprovacao ||
                      (!isNew && fluxoAprovacaoObrigatorio)
                    }
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage({ id: 'fluxoAprovacao' })
                      ),
                      value: model.getModel('fluxoAprovacao').value,
                      requestChange: handleChangeFluxoAprovacao,
                      errors: model.getModel('fluxoAprovacao').errors,
                    }}
                  />
                </Col>
              )}
            <Col md={4}>
              <Input
                data-testid="risco-nome-input"
                autoFocus={true}
                className="tw:h-12"
                disabled={disabled}
                required
                model={model.getModel('nome')}
                maxLength={300}
              />
            </Col>
            <Col md={4}>
              <ItemOrganizacaoLookup
                classNamePrefix="risco-cadastro-select"
                data-testid="risco-area-lookup"
                disabled={disabled}
                required
                model={{
                  label: capitalizeFirstLetter(resources.area),
                  value: model.getModel('area').value,
                  requestChange: handleAreaChange,
                  errors: model.getModel('area').errors,
                }}
              />
            </Col>
            {!isNew || !utilizaCodigoAutomatico(configuracao) ? (
              <Col md={4}>
                <Input
                  data-testid="risco-id-integracao-input"
                  className="tw:h-12"
                  disabled={disabled || utilizaCodigoAutomatico(configuracao)}
                  required={
                    !(disabled || utilizaCodigoAutomatico(configuracao))
                  }
                  model={model.getModel('idIntegracao')}
                />
              </Col>
            ) : null}
            <Col md={4}>
              <ColaboradorEGrupoSimplificadoLookup
                classNamePrefix="risco-cadastro-select"
                data-testid="risco-responsaveis-lookup"
                abrirEmDrawer={true}
                exibirGrupos
                labelComoTitulo
                multi
                compactMulti
                autoFocus={false}
                disabled={disabled}
                required
                model={{
                  label: intl.formatMessage(
                    {
                      id: 'selecioneColaboradoresEouGrupos',
                    },
                    { colaboradores: resources.responsaveis }
                  ),
                  value: [...responsaveis, ...gruposResponsaveis],
                  requestChange: handleChangePeopleAndGroups,
                  errors: model.getModel('responsaveis').errors,
                }}
                data={{
                  ignorarPermissoesCardMetas: true,
                  considerarPermissoesDeArea: false,
                  ignorarPermissoesAreas: true,
                }}
                parameters={{
                  ignorarPermissoesCardMetas: true,
                  considerarPermissoesDeArea: false,
                  ignorarPermissoesAreas: true,
                }}
              />
            </Col>
            <Col md={4}>
              <div className="d-flex align-items-end">
                <Tooltip
                  placement="bottom"
                  maxWidth={390}
                  disabled={!possuiFluxoAprovacaoStatusPendente}
                  text={intl.formatMessage(
                    { id: 'labelAlteracaoStatusRiscoFluxoBloqueio' },
                    { risco: resources.risco }
                  )}
                >
                  <div className="w-100">
                    <StatusItemLookup
                      classNamePrefix="risco-cadastro-select"
                      data-testid="risco-status-lookup"
                      disabled={statusItemLookupDisabled}
                      required
                      model={{
                        label: capitalizeFirstLetter(
                          intl.formatMessage({ id: 'status' })
                        ),
                        value: model.getModel('status').value,
                        requestChange: onStatusChange,
                        errors: model.getModel('status').errors,
                      }}
                      data={{ idsSelecionados: [1, 2, 3, 4, 5] }}
                    />
                  </div>
                </Tooltip>
                {exibirHistoricoFluxoStatus && (
                  <div className="ml-2 d-flex align-items-center flex-shrink-0 tw:h-12 tw:mb-4">
                    <a
                      id="icon-historico-fluxo-aprovacao"
                      onClick={handleOpenHistoricoStatus}
                    >
                      <LucideIcon
                        className="text-primary cursor-pointer"
                        icon="history"
                        size={20}
                      />
                    </a>
                  </div>
                )}
              </div>
              {possuiFluxoReprovadoAguardandoSubmissaoStatus &&
                !enviadoParaFluxoAprovacaoStatus && (
                  <div
                    style={{
                      color: '#B91C1C',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                  >
                    <LucideIcon icon="AlertTriangle" size={15} />
                    <div
                      style={{
                        fontSize: 13,
                        marginTop: 4,
                        cursor: 'pointer',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                      onClick={() => abrirModalReenvioFluxoAprovacaoStatus()}
                    >
                      {intl.formatMessage({
                        id: 'labelSuaSolicitacaoMudancaStatusFoiDevolvida',
                      })}{' '}
                      <span style={{ fontWeight: 'bold' }}>
                        {intl.formatMessage({ id: 'labelCliqueReenviar' })}
                      </span>
                    </div>
                  </div>
                )}
            </Col>
            {configuracaoRisco?.habilitarFluxoAprovacaoStatusRisco && (
              <Col md={4}>
                <FluxoAprovacaoGenericoLookup
                  classNamePrefix="risco-cadastro-select"
                  required={
                    configuracaoRisco?.fluxoAprovacaoStatusRiscoObrigatorio
                  }
                  disabled={desabilitarLookupFluxoAprovacaoStatus || disabled}
                  showHint
                  labelHint={intl.formatMessage(
                    { id: 'labelEscolhaFluxoAprovacaoStatusRisco' },
                    {
                      risco: resources.risco,
                    }
                  )}
                  data={{
                    tipoItemId: TIPO_ITEM_FLUXO_APROVACAO.RISCO,
                    tipoMudancaId:
                      TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO.ALTERACAO_STATUS_RISCO,
                  }}
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage(
                        { id: 'labelFluxoAprovacaoAlteracaoStatus' },
                        { risco: resources.risco }
                      )
                    ),
                    value: model.getModel('fluxoAprovacaoStatus').value,
                    requestChange: model.getModel('fluxoAprovacaoStatus')
                      .requestChange,
                    errors: model.getModel('fluxoAprovacaoStatus').errors,
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className={cadastroFieldClasses}>
            <Col md={utilizarToleranciaRisco ? 3 : 4}>
              <MatrizRisco
                classNamePrefix="risco-cadastro-select"
                data-testid="risco-matriz-lookup"
                required
                disabled={disabled}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'matrizRisco' },
                      { risco: resources.risco }
                    )
                  ),
                  value: model.getModel('matrizRisco').value,
                  requestChange: model.getModel('matrizRisco').requestChange,
                  errors: model.getModel('matrizRisco').errors,
                }}
              />
            </Col>
            {utilizarToleranciaRisco && (
              <Col md={3}>
                <ToleranciaRiscoLookup
                  classNamePrefix="risco-cadastro-select"
                  disabled={desabilitarToleranciaRisco || disabled}
                  saved={saved}
                  model={{
                    label: intl.formatMessage(
                      {
                        id: 'labelToleranciaRisco',
                      },
                      { risco: resources.risco }
                    ),
                    value: model.getModel('toleranciaRisco').value,
                    requestChange:
                      model.getModel('toleranciaRisco').requestChange,
                    errors: model.getModel('toleranciaRisco').errors,
                  }}
                />
              </Col>
            )}
            <Col md={utilizarToleranciaRisco ? 6 : 8}>
              <DataInicioTermino
                height="3rem"
                disabled={disabled}
                autoFormatDate={true}
                showClear={false}
                dataInicio={model.getModel('dataInicioItem')}
                dataTermino={model.getModel('dataTerminoItem')}
                required
              />
            </Col>
          </Row>
          <Row className={cadastroFieldClasses}>
            {podeVisualizarTagRisco && (
              <Col md={utilizarToleranciaRisco ? 3 : 4}>
                <TagLookup
                  classNamePrefix="risco-cadastro-select"
                  disabled={disabled}
                  multi
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage(
                        { id: 'tags' },
                        { tags: resources.tags }
                      )
                    ),
                    value: model.getModel('tags').value,
                    requestChange: model.getModel('tags').requestChange,
                  }}
                  data={{ funcionalidadesIdSelecionaveis: [7] }}
                  podeEditar={false}
                />
              </Col>
            )}
          </Row>
        </Panel>
      )}
      {(!aguardandoSelecaoFluxoObrigatorio ||
        model.getModel('fluxoAprovacao').value ||
        !isNew) && (
        <Panel header={<FormattedMessage id="informacoesComplementares" />}>
          <Row className={cadastroFieldClasses}>
            <Col md={4}>
              <ColaboradorEGrupoSimplificadoLookup
                classNamePrefix="risco-cadastro-select"
                disabled={disabled}
                abrirEmDrawer={true}
                labelComoTitulo
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'label.responsavelAvaliacao' },
                      { avaliacao: resources.avaliacao }
                    )
                  ),
                  value: model.getModel('responsavelAvaliacao').value,
                  requestChange: model.getModel('responsavelAvaliacao')
                    .requestChange,
                  errors: model.getModel('responsavelAvaliacao').errors,
                }}
                data={{
                  ignorarPermissoesCardMetas: true,
                  considerarPermissoesDeArea: false,
                  ignorarPermissoesAreas: true,
                  somenteAtivos: true,
                }}
              />
            </Col>
            <Col md={4}>
              <PeriodicidadeLookup
                classNamePrefix="risco-cadastro-select"
                clearable
                disabled={disabled || model.getModel('revisaoUnica').value}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'label.periodicidadeAvaliacao' },
                      { avaliacao: resources.avaliacao }
                    )
                  ),
                  value: model.getModel('periodicidadeAvaliacao').value,
                  requestChange: model.getModel('periodicidadeAvaliacao')
                    .requestChange,
                  errors: model.getModel('periodicidadeAvaliacao').errors,
                }}
              />
            </Col>
            <Col
              md={addonIntegracaoPowerBIAvaliacaoRisco ? 1 : 2}
              className="mt-2"
            >
              <CheckBox
                style={{ marginTop: 30 }}
                disabled={disabled}
                model={model.getModel('revisaoUnica')}
              />
            </Col>
            {addonIntegracaoPowerBIAvaliacaoRisco && (
              <Col md={2} className="mt-2">
                <CheckBox
                  style={{ marginTop: 30 }}
                  disabled={disabled}
                  model={model.getModel('utilizarValorPowerBI')}
                  onChange={handleChangeUtilizarValorPowerBI}
                />
              </Col>
            )}
            <Col
              md={addonIntegracaoPowerBIAvaliacaoRisco ? 1 : 2}
              className="mt-2"
            >
              <ArquivoUploadAnexos
                rightLabel={true}
                disabled={disabled}
                onlyRead={reprovadoDefinitivamente}
                tipoAnexo={tiposAnexos.item}
                formGroupStyle={{ marginBottom: 0 }}
                model={model.getModel('arquivos')}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                disabled={disabled}
                type="textarea"
                model={model.getModel('descricao')}
                rows={rowsDescricao < 6 ? 6 : rowsDescricao}
              />
            </Col>
            {(utilizarModelo || utilizarClassificacaoRisco || utilizarTipo) && (
              <Col md={4}>
                {utilizarModelo && (
                  <ModeloRiscoLookup
                    disabled={disabled}
                    model={model.getModel('modeloRisco')}
                  />
                )}
                {utilizarClassificacaoRisco && (
                  <ClassificacaoRiscoLookup
                    disabled={disabled}
                    model={model.getModel('classificacaoRisco')}
                  />
                )}
                {utilizarTipo && (
                  <TipoRiscoLookup
                    disabled={disabled}
                    model={{
                      label: capitalizeFirstLetter(resources.tipoRisco),
                      value: model.getModel('tipoRisco').value,
                      requestChange: model.getModel('tipoRisco').requestChange,
                      errors: model.getModel('tipoRisco').errors,
                    }}
                  />
                )}
              </Col>
            )}
          </Row>
          {configuracaoRisco?.habilitarFluxoAprovacaoAvaliacaoRisco && (
            <Row>
              <Col md={8}>
                <FluxoAprovacaoGenericoLookup
                  required={
                    configuracaoRisco?.fluxoAprovacaoAvaliacaoRiscoObrigatorio
                  }
                  disabled={disabled}
                  data={{
                    tipoItemId: TIPO_ITEM_FLUXO_APROVACAO.RISCO,
                    tipoMudancaId:
                      TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO.AVALIACAO_RISCO,
                    fluxoAvaliacaoRisco: true,
                  }}
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage(
                        { id: 'labelFluxoAprovacaoAvaliacao' },
                        { risco: resources.risco }
                      )
                    ),
                    value: model.getModel('fluxoAprovacaoAvaliacao').value,
                    requestChange: model.getModel('fluxoAprovacaoAvaliacao')
                      .requestChange,
                    errors: model.getModel('fluxoAprovacaoAvaliacao').errors,
                  }}
                />
              </Col>
            </Row>
          )}
          {model.getModel('camposCustomizados').value &&
            model.getModel('camposCustomizados').value.length > 0 && (
              <DesenharCampoCustomizado
                rowsTextArea={6}
                model={model.getModel('camposCustomizados')}
                disabled={disabled}
                mdFields={4}
              />
            )}
        </Panel>
      )}
      {configuracao.habilitarDicionarioRiscos &&
        (!aguardandoSelecaoFluxoObrigatorio ||
          model.getModel('fluxoAprovacao').value ||
          !isNew) && (
          <Panel
            header={intl.formatMessage(
              { id: 'labelDicionarioRiscos' },
              { riscos: resources.riscos }
            )}
          >
            <Row>
              <Col md={4} style={{ marginTop: 10 }}>
                <DicionarioRiscoLookup
                  disabled={disabled}
                  model={{
                    label: intl.formatMessage(
                      { id: 'labelVincularCategoriaAoRisco' },
                      { risco: resources.risco }
                    ),
                    value: model.getModel('dicionarioRisco').value,
                    requestChange:
                      model.getModel('dicionarioRisco').requestChange,
                    errors: model.getModel('dicionarioRisco').errors,
                  }}
                  clearable
                  data={{ selecaoUltimoNivel: true }}
                  checkSelected={true}
                />
              </Col>
            </Row>
            {model.getModel('dicionarioRisco').value && (
              <Row>
                <Col md={12} style={{ marginTop: 10 }}>
                  <BreadcrumbsHierarquia
                    categoria={model.getModel('dicionarioRisco').value}
                  />
                </Col>
              </Row>
            )}
          </Panel>
        )}
      {!isNew &&
        model?.getModel('configuracaoRisco')?.value
          ?.habilitarPlanoContigencia && (
          <PlanosContingenciaVinculadosView
            openLastFilter={false}
            allowNew={!disabled}
            model={model.getModel('planosContingencia')}
            requestChange={model.getModel('planosContingencia').requestChange}
          />
        )}
      {!isNew && (
        <Panel
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'itensAssociados' })
          )}
        >
          <Row>
            <Col md={12} style={{ marginTop: 20 }}>
              <TabelaItensAssociados
                handleNewClick={handleOpenItensAssociados}
                allowNew={!disabled}
                model={model.getModel('itensAssociados')}
              />
            </Col>
          </Row>
        </Panel>
      )}
      {!isNew && addonGestaoDocumentosAtivo && (
        <DocumentosAssociadosPanel
          documentosAssociados={model.getModel('documentosAssociados').value}
          onChangeDocumentosAssociados={
            model.getModel('documentosAssociados').requestChange
          }
          isDisabled={disabled}
          showBuscar={!disabled}
          showSearchBar={false}
          onOpenDocumentoAssociadoDetail={handleOpenDocumentoAssociadoDetail}
        />
      )}
      {!isNew && renderFiltroRelatorioPowerBI(disabled, model)}
      {!isNew && (
        <Panel
          open={false}
          header={intl.formatMessage({ id: 'label.historico' })}
          loadChildrenOnOpen={true}
        >
          <Historico
            url={`/Risco/ObterHistorico`}
            id={model.getModel('id').value}
          />
        </Panel>
      )}
    </div>
  );
};

export default RiscoResumoEdit;
